import Component from '../classes/Component';
import GSAP from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

GSAP.registerPlugin(ScrollTrigger);

export default class Parallax extends Component {
  constructor({ element, elements }) {
    super({ element, elements });
    this.element = element;
    this.mm = GSAP.matchMedia(); // Create a matchMedia instance
    this.animateIn();
  }

  animateIn() {
    const yRange = GSAP.utils.random(8, 15);
    const rotationRange = GSAP.utils.random(-30, 40);
    const scaleMin = 0.2;
    const scaleMax = 1;

    // Randomized horizontal parallax range for the desktop scrub
    const xParallaxRange = GSAP.utils.random([-5, 5]);

    // Randomly choose the mobile slide-in starting position (only 20% or -20% off-screen)
    const mobileSlideStart = GSAP.utils.random([20, -20]);

    // Initial State for ALL: Set scale to minimum and ensure it starts ON-SCREEN.
    // We remove the initialX here to prevent the desktop rotation/alignment issue.
    GSAP.set(this.element, {
      scale: scaleMin,
      xPercent: 0,
      yPercent: 0, // Ensure Y is also clean
      rotation: 0, // Ensure rotation is clean
      transformOrigin: 'bottom center',
    });

    // --- START: MEDIA QUERIES ---

    // Desktop Animation (min-width: 1024px)
    this.mm.add('(min-width: 1024px)', () => {
      // DESKTOP SLIDE-IN is now removed. The element starts on-screen.
      // We only keep the scale-in and the parallax scrub.

      // Store the scale trigger so we can kill it later
      const scaleTrigger = ScrollTrigger.create({
        trigger: this.element,
        start: 'top 90%',
        onEnter: () => {
          GSAP.to(this.element, {
            scale: scaleMax,
            duration: 0.75,
            ease: 'expo.out',
          });
        },
      });

      // 🌟 DESKTOP PARALLAX SCRUB: Now starts from a clean xPercent: 0 position.
      const parallaxTween = GSAP.to(this.element, {
        yPercent: yRange,
        xPercent: xParallaxRange,
        rotation: rotationRange,
        ease: 'none',
        scrollTrigger: {
          trigger: this.element,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5,
          markers: false,
        },
      });

      // Return a cleanup function
      return () => {
        // slideInTween?.scrollTrigger?.kill(); // Removed slideInTween cleanup
        // slideInTween?.kill();
        scaleTrigger?.kill();
        parallaxTween?.scrollTrigger?.kill();
        parallaxTween?.kill();
      };
    });

    // Mobile Animation (max-width: 1023px)
    this.mm.add('(max-width: 1023px)', () => {
      // 🌟 FIX: We set the off-screen starting position ONLY HERE for mobile
      GSAP.set(this.element, { xPercent: mobileSlideStart });

      // Mobile slide-in to center (0%) using a scrub for immediate start
      const tween = GSAP.to(this.element, {
        scale: scaleMax,
        xPercent: 0, // Animate to 0 (center)
        rotation: rotationRange / 2, // Rotate as it slides in
        ease: 'power2.out',
        scrollTrigger: {
          trigger: this.element,
          start: 'top bottom', // Start instantly
          end: 'center center', // Finish by center
        },
      });

      return () => {
        tween?.scrollTrigger?.kill();
        tween?.kill();
      };
    });
  }
  destroy() {
    console.log('killed');
    // Revert the matchMedia instance, which automatically cleans up
    // all the animations and ScrollTriggers created within it.
    this.mm.revert();
  }
}
